export default __webpack_public_path__ + "static/media/timerIcon.fc7119fa.svg";